import React, { createContext, useContext, useEffect, useState } from 'react';
import { AuthAPI, API, getToken, setToken, clearToken } from '../api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = getToken();
    if (token) sessionStorage.setItem('bm_token', token); // pin this tab to the account it opened with
    if (!token) { setLoading(false); return; }
    AuthAPI.me().then(setUser).catch(() => clearToken()).finally(() => setLoading(false));
  }, []); // mount only: restore session from stored token

  const finish = async (data) => {
    setToken(data.token);
    setUser(data.user);
    // if a song request was started before signing in, create it now
    const pending = localStorage.getItem('bm_pending');
    if (pending && data.user.role === 'business') {
      try { await API.createRequest(JSON.parse(pending)); } catch (e) { console.error('pending request failed', e); }
      localStorage.removeItem('bm_pending');
    }
    return data.user;
  };

  const login = async (creds) => finish(await AuthAPI.login(creds));
  const register = async (data) => finish(await AuthAPI.register({ ...data, create_request: !localStorage.getItem('bm_pending') }));
  const resetPassword = async (token, password) => finish(await AuthAPI.reset(token, password));
  const logout = () => { clearToken(); setUser(null); };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, resetPassword, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
